class MediaTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('.product__media-panel'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tab));
    });
  }

  activate(name) {
    if (!name || this.dataset.active === name) return;
    this.dataset.active = name;

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === name;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === name;
      panel.toggleAttribute('hidden', !isActive);
    });

    if (name !== 'intro') {
      const video = this.querySelector('[data-panel="intro"] video');
      if (video && typeof video.pause === 'function') video.pause();
    }
  }
}

if (!customElements.get('media-tabs')) {
  customElements.define('media-tabs', MediaTabs);
}
